if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-sticky-atc-btn]');
      this.priceEl = this.querySelector('[data-sticky-atc-price]');
      this.formId = this.dataset.formId;
      this.sectionId = this.dataset.section;
      this.moneyFormat = this.dataset.moneyFormat;
      this.textAdd = this.dataset.textAdd;
      this.textSelect = this.dataset.textSelect;

      // Observe the buy-buttons block for visibility toggle
      const sectionEl = document.getElementById('shopify-section-' + this.sectionId);
      this.watchTarget = sectionEl?.querySelector('.product-info__block--buy-buttons');

      if (this.watchTarget) {
        // Delay one frame so header has final layout height
        requestAnimationFrame(() => {
          this.setupObserver();
          const header = document.querySelector('.cc-header');
          if (header) {
            this.headerResizeObserver = new ResizeObserver(() => this.setupObserver());
            this.headerResizeObserver.observe(header);
          }
        });
      }

      // Use MutationObserver to reliably detect button state changes:
      // - childList: when the button area (data-dynamic-variant-content) is swapped by variant-picker.js
      // - attributes/disabled: when the button's disabled attribute changes in-place
      const form = document.getElementById(this.formId);
      if (form) {
        this.mutationObserver = new MutationObserver(() => {
          clearTimeout(this._syncTimer);
          this._syncTimer = setTimeout(() => this.syncButtonState(), 30);
        });
        this.mutationObserver.observe(form, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'class']
        });
      }

      // Price updates via variant change event (scoped to this product's form)
      document.addEventListener('on:variant:change', (e) => this.onVariantChange(e));

      this.btn.addEventListener('click', () => this.onBtnClick());
    }

    disconnectedCallback() {
      this.intersectionObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.headerResizeObserver?.disconnect();
      clearTimeout(this._syncTimer);
    }

    getHeaderHeight() {
      const header = document.querySelector('.cc-header');
      return header ? header.getBoundingClientRect().height : 0;
    }

    setupObserver() {
      this.intersectionObserver?.disconnect();
      const headerHeight = this.getHeaderHeight();
      this.intersectionObserver = new IntersectionObserver(
        (entries) => this.onIntersect(entries),
        { threshold: 0, rootMargin: `-${headerHeight}px 0px 0px 0px` }
      );
      this.intersectionObserver.observe(this.watchTarget);
    }

    onIntersect(entries) {
      this.classList.toggle('sticky-atc--visible', !entries[0].isIntersecting);
    }

    /** Returns the real [name="add"] button from this product's form. */
    getRealBtn() {
      return document.getElementById(this.formId)?.querySelector('[name="add"]');
    }

    /** Mirrors the real ATC button's enabled/disabled state and loading classes onto the sticky button. */
    syncButtonState() {
      const realBtn = this.getRealBtn();
      if (!realBtn) return;

      // Kopiuj klasy loadera i sukcesu z głównego przycisku na sticky
      this.btn.classList.toggle('is-loading', realBtn.classList.contains('is-loading'));
      this.btn.classList.toggle('is-success', realBtn.classList.contains('is-success'));

      // Nie zmieniaj tekstu podczas ładowania (product-form.js chwilowo blokuje przycisk)
      if (realBtn.classList.contains('is-loading')) return;

      if (realBtn.disabled) {
        this.btn.dataset.action = 'select';
        this.btn.textContent = this.textSelect;
      } else {
        this.btn.dataset.action = 'add';
        this.btn.textContent = this.textAdd;
      }
    }

    onVariantChange(e) {
      const { variant, form } = e.detail;

      // Update price display only for this product's events
      if (form?.id === this.formId && variant) {
        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
          this.priceEl.textContent = Shopify.formatMoney(variant.price, this.moneyFormat);
        }
      }
    }

    onBtnClick() {
      const realBtn = this.getRealBtn();

      if (realBtn && !realBtn.disabled) {
        // Delegate to the real ATC button so product-form.js handles cart logic
        realBtn.click();
      } else {
        // Scroll to variant picker so user can pick a different / first variant
        const sectionEl = document.getElementById('shopify-section-' + this.sectionId);
        const picker = sectionEl?.querySelector('.product-options');
        if (picker) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    }
  }

  customElements.define('sticky-atc', StickyAtc);
}
